import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Pagination, PaginationItem } from "@mui/material";
import React from "react";

import { DEFAULT_PAGINATION_LIMIT } from "../../../globalConstants";

export default function PaginationControls({
  resultCount,
  handleChange,
  currentPage,
  limit = DEFAULT_PAGINATION_LIMIT,
}) {
  const count = Math.ceil(resultCount.total / limit);
  const isSinglePage = count <= 1;

  return (
    <Pagination
      count={count}
      onChange={!isSinglePage ? handleChange : undefined}
      page={currentPage}
      disabled={isSinglePage}
      sx={{
        marginTop: "1rem",
        pointerEvents: isSinglePage ? "none" : "auto",
      }}
      renderItem={(item) => (
        <PaginationItem
          slots={{
            previous: ArrowBack,
            next: ArrowForward,
          }}
          {...item}
        />
      )}
    />
  );
}
